/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 *
 * @export
 * @interface ResponseFcmTopic
 */
export interface ResponseFcmTopic {
    /**
     *
     * @type {ResponseResult}
     * @memberof ResponseFcmTopic
     */
    result: ResponseResult;
}

/**
 * Check if a given object implements the ResponseFcmTopic interface.
 */
export function instanceOfResponseFcmTopic(value: object): value is ResponseFcmTopic {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function ResponseFcmTopicFromJSON(json: any): ResponseFcmTopic {
    return ResponseFcmTopicFromJSONTyped(json, false);
}

export function ResponseFcmTopicFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseFcmTopic {
    if (json == null) {
        return json;
    }
    return {

        'result': ResponseResultFromJSON(json['result']),
    };
}

export function ResponseFcmTopicToJSON(json: any): ResponseFcmTopic {
    return ResponseFcmTopicToJSONTyped(json, false);
}

export function ResponseFcmTopicToJSONTyped(value?: ResponseFcmTopic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'result': ResponseResultToJSON(value['result']),
    };
}
